// Moved AppTitle/AppName into environment files.

export const site_types: string[] = [
  'Capital Works Project',
  'Commercial Site',
  'Defence',
  'Education',
  'Health',
  'Hotel & Hospitality',
  'Infrastructure',
  'Leisure Site',
  'Maintenance',
  'Major Project Development Site',
  'Managed Site',
  'Multi Dwelling Site',
  'Office',
  'Owned Site',
  'Renewables',
  'Residential Building Site',
  'Retail Development Site',
  'Retail Site',
  'School Site',
  'Serviced Site',
  'Shopping Centre',
  'Single Dwelling Site',
  'Warehouse',
  'Other'
];

export const site_statuses: string[] = [
  'Pre-Construction',
  'Under Construction',
  'Hand Over Complete',
  'Under Active Management',
  'Maintenance',
  'Archived',
  'On Hold'
];

